import Circle from "components/Pattern/Circle";
import { lang } from "constant/lang";
import border1 from "images/pattern/border-1.svg";
import box1 from "images/pattern/box-1.svg";
import arrow1 from "images/pattern/arrow-1.svg";
import React from "react";

const MissionSection = () => {
  return (
    <div className="flex mb-16 md:mb-32">
      <Circle
        variant="two"
        className="absolute left-12 md:left-0 -translate-x-full md:translate-x-0"
      />
      <div className="flex flex-col w-full ml-16 md:ml-[25%] mr-6">
        <div className="relative mb-8 md:mb-24">
          <div className="absolute -right-28 -top-9">
            <img className="w-[136px] min-w-[136px]" src={box1} alt={"box1"} />
          </div>
          <span className="font-yesevaOne text-wce-yellow text-2xl md:text-6.5xl">
            {lang.about.misson.title}
          </span>
        </div>
        <div className="relative max-w-[750px] text-white text-sm md:text-xl">
          <div className="absolute -right-6 md:-right-32 -top-4 md:-top-9">
            <img
              className="w-[210px] md:w-[384px] md:min-w-[384px]"
              src={border1}
              alt={"border1"}
            />
          </div>
          <div className="font-bold mb-4">Vision</div>
          <div className="mb-10">{lang.about.misson.vision}</div>
          <div className="relative">
            <div className="absolute -left-8 -bottom-10 -translate-x-full">
              <img className="w-[86px] min-w-[86px]" src={box1} alt={"box1"} />
            </div>
            <div className="absolute -left-32 -bottom-20 -translate-x-full hidden md:block">
              <img
                className="w-[86px] min-w-[86px]"
                src={arrow1}
                alt={"arrow1"}
              />
            </div>
            <div className="font-bold mb-4">Mission</div>
            <div>{lang.about.misson.mission}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MissionSection;
